import { gap, Grid, media, spacing } from '@lamimed/pantheon';
import styled from 'styled-components';

export const Wrapper = styled(Grid.Wrapper)`
  position: relative;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: ${spacing.medium};
  align-items: start;

  ${media.greaterThan('tablet')`
    grid-template-columns: repeat(2, 1fr);
  `}
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;

  ${media.greaterThan('tablet')`
    width: 100%;
    align-items: flex-start;
  `}
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${media.greaterThan('tablet')`
    align-items: flex-start;
    text-align: initial;
  `};
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${spacing.small};

  ${gap(spacing.small)};
`;
